import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

function ImgPreviewIcon({ fileUrl }) {
  const navigate = useNavigate();

  return (
    <>
      {fileUrl ? (
        <ImgPreviewWrapper>
          <img
            style={{
              width: "100%",
              height: "100%",
            }}
            src={fileUrl}
            alt="이미지"
          />
        </ImgPreviewWrapper>
      ) : null}
    </>
  );
}

export default ImgPreviewIcon;

const ImgPreviewWrapper = styled.div.attrs((props) => {})`
  width: 17px;
  height: 17px;
`;
